/**
 * @file prescription-detail.component.ts
 */
import { Component, OnInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { Prescription } from 'src/app/interfaces/prescription.interface';
import { MemberService } from 'src/app/services/member/member.service';
import { AppCenterAnalytics } from '../../services/app-insights/app-insights';
import { AppInsightsService } from '../../services/app-insights/app-insights.service';

@Component({
  selector: 'app-prescription-detail',
  templateUrl: './prescription-detail.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrescriptionDetailComponent implements OnInit {

  isLoading = false;
  isError!: boolean;
  errMsg!: string;
  prescription!: Prescription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { prescription: Prescription, isChargeShipEnabled: boolean },
    public readonly multilingualService: MultilingualService,
    private readonly appInsightsService: AppInsightsService,
    public readonly memberService: MemberService,
    private readonly changeDetectionRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<PrescriptionDetailComponent>
  ) { }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.PRESCRIPTIONS_DETAILS_VIEWED);
    this.prescription = this.data.prescription;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public print(): void {
    this.appInsightsService.trackPageView(this.multilingualService?.langMap?.LABEL_PRESCRIPTION_PDF_FILE_NAME + ' PDF VIEWED');
    let prescriptionCopy = { ...this.prescription };
    if (!prescriptionCopy.autoRefillReminderAllowed) {
      prescriptionCopy.autoRefillReminder = null;
    }
    if (!prescriptionCopy.autoRefillChargeShipAllowed) {
      prescriptionCopy.autoRefillChargeShip = null;
    }

    this.isLoading = true;
    this.memberService.getPrescriptionPdf(prescriptionCopy, this.data.isChargeShipEnabled).subscribe(
      res => {
        this.isLoading = false;
        this.changeDetectionRef.detectChanges();
        const blob = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      }, (error) => {
        this.errMsg = error;
        this.isLoading = false;
        this.changeDetectionRef.detectChanges();
        this.isError = true;
      }
    );
  }
}
